import React from 'react';
import './dateRangeFilter.css';

export interface DateRangeFilterProps {
  startTime: string;
  endTime: string;
  onFilterChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onResetFilters: () => void;
  className?: string;
}

export default function DateRangeFilter({
  startTime,
  endTime,
  onFilterChange,
  onResetFilters,
  className = '',
}: DateRangeFilterProps) {
  return (
    <div className={`dateFiltersContainer ${className}`}>
      <div className="dateFiltersRow">
        <div className="dateFilterItem">
          <label>Начало периода</label>
          <input
            type="date"
            name="startTime"
            value={startTime || ''}
            onChange={onFilterChange}
            placeholder="DD-MM-YYYY"
          />
        </div>
        <div className="dateFilterItem">
          <label>Конец периода</label>
          <input type="date" name="endTime" value={endTime || ''} onChange={onFilterChange} placeholder="DD-MM-YYYY" />
        </div>
        <div className="dateFilterItem">
          <button className="resetFiltersBtn" onClick={onResetFilters}>
            Сбросить фильтры
          </button>
        </div>
      </div>
    </div>
  );
}
